import { ChangeDetectionStrategy, Component, Inject, InjectionToken } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '@mds/angular-core-material';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { TVP_TOOLBAR_LOGO } from '../../config/context';

export const TVP_BOTTOM_TOOLBAR = new InjectionToken<boolean>('hasBottomToolbar');

@Component({
  selector: 'tvp-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {
  isLoading$: Observable<boolean>;
  logo$: Observable<string>;
  hasBottomToolbar$: Observable<boolean>;

  constructor(
    private router: Router,
    loader: LoadingService,
    @Inject(TVP_BOTTOM_TOOLBAR) hasBottomToolbarSubject: BehaviorSubject<boolean>,
    @Inject(TVP_TOOLBAR_LOGO) logoSubject: ReplaySubject<string>
  ) {
    this.isLoading$ = loader.isLoading$;
    this.logo$ = logoSubject.asObservable();
    this.hasBottomToolbar$ = hasBottomToolbarSubject.asObservable();
  }

  contact(): void {
    if (this.router.routerState.root.snapshot.queryParamMap.has('token')) {
      this.router.navigate(['appointment/support'], { queryParamsHandling: 'preserve' });
    } else {
      this.router.navigate(['appointment/support']);
    }
  }
}
